import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import AuthLeftBanner from "./AuthLeftBanner";
import LoginView from "./LoginView";
import RegisterView from "./RegisterView";
import OtpView from "./OtpView";
import "./AuthPage.css";

const AuthPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuth } = useSelector((state) => state.Athentication);

  // Determine initial view from pathname (/register, /login, /verify-otp)
  const getInitialView = () => {
    const path = location.pathname.toLowerCase();
    if (path.includes("register")) return "register";
    if (path.includes("otp")) return "otp";
    return "login";
  };

  const [currentView, setCurrentView] = useState(getInitialView());
  const [authDetails, setAuthDetails] = useState({
    mobile: "",
    OTP: "",
    context: "login", // 'login' | 'register'
  });
  const [prefilledMobile, setPrefilledMobile] = useState("");

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuth) {
      navigate("/dashboard");
    }
  }, [isAuth, navigate]);

  // Update view on route change
  useEffect(() => {
    const path = location.pathname.toLowerCase();
    if (path.includes("register") && currentView !== "register" && currentView !== "otp") {
      setCurrentView("register");
    } else if (path.includes("login") && currentView !== "login" && currentView !== "otp") {
      setCurrentView("login");
    }
  }, [location.pathname]);

  const handleSwitchToRegister = () => {
    setCurrentView("register");
    window.history.replaceState(null, "", "/register");
  };

  const handleSwitchToLogin = () => {
    setCurrentView("login");
    window.history.replaceState(null, "", "/login");
  };

  const handleOtpRequested = (details) => {
    setAuthDetails(details);
    setCurrentView("otp");
  };

  const handleBackFromOtp = () => {
    if (authDetails.context === "register") {
      setCurrentView("register");
    } else {
      setCurrentView("login");
    }
  };

  const handleEditMobile = () => {
    if (authDetails.context === "register") {
      setPrefilledMobile(authDetails.mobile);
      setCurrentView("register");
    } else {
      setCurrentView("login");
    }
  };

  const handleSwitchToRegisterWithMobile = (mobile) => {
    setPrefilledMobile(mobile);
    setCurrentView("register");
  };

  const getPageTitle = () => {
    if (currentView === "register") return "Create Account | EwRealty";
    if (currentView === "otp") return "Verify OTP | EwRealty";
    return "Sign In | EwRealty";
  };

  return (
    <div className="mgh-auth-page-wrapper">
      <Helmet>
        <title>{getPageTitle()}</title>
        <meta
          name="description"
          content="Login or create an account with EwRealty to find, buy, sell, or rent verified properties."
        />
      </Helmet>

      <div className="mgh-auth-container-box">
        {/* Left Hero / Brand Banner */}
        <AuthLeftBanner currentView={currentView} />

        {/* Right Form Container */}
        <main className="mgh-auth-main">
          {currentView === "login" && (
            <LoginView
              onSwitchToRegister={handleSwitchToRegister}
              onOtpRequested={handleOtpRequested}
            />
          )}

          {currentView === "register" && (
            <RegisterView
              onSwitchToLogin={handleSwitchToLogin}
              onOtpRequested={handleOtpRequested}
              prefilledMobile={prefilledMobile}
            />
          )}

          {currentView === "otp" && (
            <OtpView
              authDetails={authDetails}
              onBack={handleBackFromOtp}
              onEditMobile={handleEditMobile}
              onSwitchToRegisterWithMobile={handleSwitchToRegisterWithMobile}
            />
          )}
        </main>
      </div>
    </div>
  );
};

export default AuthPage;
